var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.options,"reduce":option => option.value,"label":"name","clearable":false,"searchable":true},on:{"input":(option) => this.$emit('input', option)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }